import React from 'react';
import { View } from '@react-pdf/renderer';

import BuyerFinancing from '@/components/Contract/Download/FinancialInspection/BuyerFinancing';
import CashOffer from '@/components/Contract/Download/FinancialInspection/CashOffer';
import MortgageFinancing from '@/components/Contract/Download/FinancialInspection/MortgageFinancing';
import { Contract } from '@/types/ContractType';
import { styles } from '../style';

const CashOfferComponent = ({ contract }: { contract: Contract }) => {
  return (
    <View style={styles.section}>
      {contract?.offerSpecifics?.offerType === 'Financed' ? (
        <>
          <BuyerFinancing />
          <MortgageFinancing contract={contract} />
        </>
      ) : (
        <CashOffer />
      )}
    </View>
  );
};

export default CashOfferComponent;
